import {
    UpCircleOutlined, DownCircleOutlined, CheckCircleOutlined, CloseCircleOutlined, QuestionCircleOutlined,
} from '@ant-design/icons';

export const FILTER_BADGE_ICONS = {
    ready: { Icon: CheckCircleOutlined, style: { color: 'var(--color-success)' }, label: 'Ready for Migration' },
    not_ready: { Icon: CloseCircleOutlined, style: { color: 'var(--card-text-red)' }, label: 'Not Ready for Migration' },
    unknown: { Icon: QuestionCircleOutlined, style: {}, label: 'Unknown' },
    oversized_cpu: { Icon: UpCircleOutlined, style: { color: 'var(--card-text-amber)' }, label: 'Oversized vCPU' },
    oversized_ram: { Icon: UpCircleOutlined, style: { color: 'var(--card-text-amber)' }, label: 'Oversized RAM' },
    undersized_cpu: { Icon: DownCircleOutlined, style: { color: 'var(--card-text-amber)' }, label: 'Undersized vCPU' },
    undersized_ram: { Icon: DownCircleOutlined, style: { color: 'var(--card-text-amber)' }, label: 'Undersized RAM' },
};

export const ellipsisDropdownLabels = [
    { key: '1', label: 'Ignore Optimizations' },
    { key: '2', label: 'Download CSV' },
];

export const ignoreAllOptimizationsConfig = {
    cpu: ['undersized', 'oversized'],
    ram: ['undersized', 'oversized'],
    modernization: ['osm', 'sqlm'],
    storage: ['undersized', 'oversized'],
};

// Shared column mapping: key is used in table/customization, label is displayed in UI
export const COLUMN_CONFIG = [
    { key: 'name', label: 'VM Name', default: true },
    { key: 'ip', label: 'IP', default: true },
    { key: 'host', label: 'Hostname', default: true },
    { key: 'powerState', label: 'Power State', default: true },
    { key: 'reportedOsVersion', label: 'Reported OS Version', default: true },
    { key: 'configuredOsVersion', label: 'Configured OS Version', default: true },
    { key: 'tags', label: 'Tags', default: false },
    { key: 'moveGroup', label: 'Move Group', default: false },
    { key: 'application', label: 'Application', default: false },
    { key: 'vcpus', label: 'vCPUs', default: false },
    { key: 'storage', label: 'Storage', default: false },
    { key: 'memory', label: 'Memory', default: false },
];

// Helper to get key from label
export const getKeyFromLabel = (label) => {
    const col = COLUMN_CONFIG.find((c) => c.label === label);
    return col ? col.key : label;
};

// Helper to get label from key
export const getLabelFromKey = (key) => {
    const col = COLUMN_CONFIG.find((c) => c.key === key);
    return col ? col.label : key;
};

export const defaultSelectedColumns = COLUMN_CONFIG.filter((col) => col.default).map((col) => col.label);

export const selectableColumns = COLUMN_CONFIG.map((col) => col.label);

export const filterValues = {
    READY_FOR_MIGRATION: 'ready',
    NOT_READY_FOR_MIGRATION: 'not_ready',
    UNKNOWN: 'unknown',
};
// cpu and ram filter mappings
export const CPU_FILTER_MAP = {
    undersized_cpu: 'undersized',
    oversized_cpu: 'oversized',
};

export const RAM_FILTER_MAP = {
    undersized_ram: 'undersized',
    oversized_ram: 'oversized',
};

export const discoveryInventoryDropdownFilters = [
    { label: 'Ready for Migration', value: filterValues.READY_FOR_MIGRATION },
    { label: 'Not Ready for Migration', value: filterValues.NOT_READY_FOR_MIGRATION },
    { label: 'Undersized vCPU', value: 'undersized_cpu' },
    { label: 'Oversized vCPU', value: 'oversized_cpu' },
    { label: 'Undersized RAM', value: 'undersized_ram' },
    { label: 'Oversized RAM', value: 'oversized_ram' },
    // { label: 'OS Optimization' , value: 'os-optimization' },
    { label: 'Unknown', value: filterValues.UNKNOWN },
];

export const discoveryInventoryMainTopBarFilters = [
    { label: 'All', value: 'all' },
    { label: 'Ready', value: filterValues.READY_FOR_MIGRATION },
    { label: 'Not Ready', value: filterValues.NOT_READY_FOR_MIGRATION },
    { label: 'Unknown', value: filterValues.UNKNOWN },
];
